// Only what en-AU says differently; every other string is en-US (mergeLocaleResources).
export const billing = {} as const;
